/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingProfileConfig } from '../../config/loading.config';
export interface ILoadingOrganizationProfilePluginMethods
  extends IPluginMethodMap {
  getLoadingOrganizationProfileSync(args?: any): any;
}

export class LoadingOrganizationProfilePlugin implements IAgentPlugin {
  readonly methods: ILoadingOrganizationProfilePluginMethods;

  constructor() {
    this.methods = {
      getLoadingOrganizationProfileSync:
        this.getLoadingOrganizationProfileSync.bind(this),
    };
  }

  getLoadingOrganizationProfileSync(args?: any) {
    return {
      loading: loadingProfileConfig,
    };
  }
}
